import { getParser } from "bowser";

export default getParser(window.navigator.userAgent);
